import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableEmployee from "./components/TableEmployee";

export function EmployeeRegisterPage() {

    return (
        <ToastProvider>
            <Dashboard>
                <TableEmployee />
                <Toast />
            </Dashboard>
        </ToastProvider>
    )
}